/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExtendedTokenGate } from './ExtendedTokenGate';
import {
    ExtendedTokenGateFromJSON,
    ExtendedTokenGateFromJSONTyped,
    ExtendedTokenGateToJSON,
} from './ExtendedTokenGate';

/**
 * 
 * @export
 * @interface TokenGate
 */
export interface TokenGate {
    /**
     * Must hold an NFT of the given collection to unlock
     * @type {ExtendedTokenGate}
     * @memberof TokenGate
     */
    tokenGate: ExtendedTokenGate;
}

/**
 * Check if a given object implements the TokenGate interface.
 */
export function instanceOfTokenGate(value: object): value is TokenGate {
    let isInstance = true;
    isInstance = isInstance && "tokenGate" in value && value["tokenGate"] !== undefined;

    return isInstance;
}

export function TokenGateFromJSON(json: any): TokenGate {
    return TokenGateFromJSONTyped(json, false);
}

export function TokenGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenGate': ExtendedTokenGateFromJSON(json['token_gate']),
    };
}

export function TokenGateToJSON(value?: TokenGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token_gate': ExtendedTokenGateToJSON(value.tokenGate),
    };
}

